import { ParcelMethodType } from "@syla/shared/types/models/AccountBase";
import React from "react";
import { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";
import { SiFifo } from "../../../../images/icons/components/SiFifo";
import { SiHifo } from "../../../../images/icons/components/SiHifo";
import { SiLifo } from "../../../../images/icons/components/SiLifo";
import { SiLtfo } from "../../../../images/icons/components/SiLtfo";

import {
  SingleSelectorField,
  SingleSelectorFieldProps,
} from "../../../forms/SingleSelectorField";
import { StandardSelectOption } from "../../../selector/parts/SelectOption";

export function ParcelMethodSelectorInputField<
  TFormValues extends FieldValues,
>({
  form,
  name,
  ...props
}: {
  form: UseFormReturn<TFormValues>;
  name: FieldPath<TFormValues>;
} & Omit<
  SingleSelectorFieldProps<TFormValues, string>,
  "form" | "name" | "options" | "wrapText"
>) {
  return (
    <SingleSelectorField
      form={form}
      name={name}
      options={ParcelMethodOptions}
      wrapText
      {...props}
    />
  );
}

const ParcelMethodOptions: StandardSelectOption<ParcelMethodType>[] = [
  {
    value: ParcelMethodType.LTFO,
    data: {
      label: "Lowest Tax First Out (LTFO)",
      icon: <SiLtfo fontSize="1.2em" />,
      description:
        "Intelligently select the parcel that will produce the lowest tax outcome to be disposed.",
    },
  },
  {
    value: ParcelMethodType.FIFO,
    data: {
      label: "First In First Out (FIFO)",
      icon: <SiFifo fontSize="1.2em" />,
      description: "The oldest asset acquired is the first to be disposed.",
    },
  },
  {
    value: ParcelMethodType.LIFO,
    data: {
      label: "Last In First Out (LIFO)",
      icon: <SiLifo fontSize="1.2em" />,
      description:
        "The most recent asset acquired is the first to be disposed.",
    },
  },
  {
    value: ParcelMethodType.HIFO,
    data: {
      label: "Highest In First Out (HIFO)",
      icon: <SiHifo fontSize="1.2em" />,
      description:
        "The asset with the highest cost base is the first to be disposed.",
    },
  },
];
